import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, styled } from '@mui/material';
import { getAllStories } from '../apiCalls/stories/api_v1_stories';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

import dummyImg from '../static/img/home/ga_dummy_img.avif'
import SkillCard from './SkillCard';


const StoryCircle = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: -1,
    background: 'linear-gradient(45deg, #FAAE1C, #FFB938)',
    borderRadius: '50%'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 1,
    background: theme.palette.background.default,
    borderRadius: '50%'
  }
}));

const StoryImage = styled(Box)({
  position: 'absolute',
  inset: 3,
  zIndex: 2,
  borderRadius: '50%',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
});

const GamezTips = ({ skillLevel }) => {
  const [stories, setStories] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const gameUuid = queryParams.get('uuid');
  const path = window.location.pathname;
  const isDesktop = useMediaQuery('(min-width:900px)');
  const navigate = useNavigate();

  const ScrollContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    overflowX: 'auto',
    gap: isDesktop ? theme.spacing(1) : theme.spacing(2),
    padding: theme.spacing(2),
    flexDirection: isDesktop ? 'column' : 'row',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    position: 'relative',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: 32,
      pointerEvents: 'none',
      zIndex: 1
    },
  }));

  useEffect(() => {
    const fetchStories = async () => {
      try {
        // let skillLevel = localStorage.getItem("skillLevel");
        if (path == '/game' && (gameUuid != null || gameUuid != undefined || gameUuid != "")) {
          const response = await getAllStories({ "uuid": gameUuid, "skillLevel": skillLevel });
          if (response.status === 200) {
            setStories(response.data.data.stories);
          }
        }
        else {
          const response = await getAllStories({ "skillLevel": skillLevel });
          if (response.status === 200) {
            setStories(response.data.data.stories);
          }
        }

      } catch (error) {
        console.error('Error fetching stories:', error);
      }
    };
    fetchStories();
  }, [skillLevel]);

  return (
   <Box sx={{ width: "100%", pr:1, pl:1 }}>
  {/* ✅ Card for Gamez Tips + Stories */}
  <Card
    sx={{
      p: 2,
      pb: 0,
      pt: 0,
      mb: 2,
     backgroundColor: { xs: "transparent !important", md: "#1A1A1A", lg: "#1A1A1A" }, 
      borderRadius: 3,
      boxShadow: { xs: "none !important", md:"0 4px 12px rgba(0,0,0,0.3)", lg:"0 4px 12px rgba(0,0,0,0.3)"} ,
      display: "flex",
      flexDirection: "column",
      alignItems: {xs: "start", md: "center", lg: "center"}, // center horizontally
      backgroundImage: { xs: "none !important", md:"none", lg:"none"}
    }}
  >
    <Typography
      variant="h6"
      sx={{ color: "white", mt: 2 }}
    >
      Gamez Tips
    </Typography>

    <ScrollContainer
      sx={{
        
        width: "100%",
      }}
    >
      {stories.map((story, index) => (
        <Box
          key={story.uuid}
          sx={{ display: "flex", justifyContent: "center" }}
          onClick={() => {
            navigate("/tips", {
              state: { stories: stories, currIndex: index },
            });
          }}
        >
          <StoryCircle>
            <StoryImage>
              <img
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = dummyImg;
                }}
                src={story.thumbnail}
                alt="Story thumbnail"
              />
            </StoryImage>
          </StoryCircle>
        </Box>
      ))}
    </ScrollContainer>
  </Card>

  {/* ✅ Second Card for SkillCard (already styled) */}
  <Box sx={{ mt: 2, width: "100%", display: "flex", justifyContent: "center" }}>
    <SkillCard />
  </Box>
</Box>
  );
};

export default GamezTips;